import React, { Component, } from 'react';
import PropTypes from 'prop-types';
import { Navigate, } from 'react-router-dom';
import './Login.css';
import StandaloneAuth from './StandaloneAuth';
import AuthUtils from '../../modules/AuthUtils';
import TokenRefreshManager from '../../modules/TokenRefreshManager';
import pkg from '../../../package.json';

export default class Login extends Component {
  handleTenantSignIn = (authResponse) => {
    const { registerAuthToken, } = this.props;

    const authData = {
      ...authResponse, // Include all other fields
      token: authResponse.accessToken || authResponse.token,
      tenantUserId: authResponse.tenantUserId,
    };

    // Store the authentication response
    window.localStorage.setItem('PAYIT_TOKEN', JSON.stringify(authData));
    registerAuthToken(authData);

    // Start token refresh manager
    TokenRefreshManager.start();
  };

  render() {
    // Read from the store, not component state: a session can also arrive from the
    // boot-time refresh or from unlocking, neither of which goes through this
    // component. Deriving it here means any of them redirects on to the dashboard.
    const { authentication, } = this.props;
    const isAuthenticated = !!authentication.token && AuthUtils.isTokenValid(authentication.token);

    if (isAuthenticated) {
      return <Navigate to="/dashboard" replace />;
    }

    return (
      <div className="container login_container">
        <div className='login_card-wrapper row'>
          <div className="container-fluid page-title col-6">
            <div className="mt-3 title">Support Admin</div>
            <div className="version">Athos v{pkg.version}</div>
          </div>
          <div className="login_form container justify-content-center col-lg-6 col-sm-12">
            <StandaloneAuth handleTenantSignIn={this.handleTenantSignIn} />
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  registerAuthToken: PropTypes.instanceOf(Function).isRequired,
  authentication: PropTypes.object,
};

Login.defaultProps = {
  authentication: {},
};
